import type { z } from "zod";

import type { ProductCategoryType } from "../../types";
import { useBaseProductFormSchema } from "./use-base-product-form-schema";

export const useEditProductFormSchema = (
  productCategory: ProductCategoryType
) => {
  const baseSchema = useBaseProductFormSchema(productCategory);

  return baseSchema;
};

export type EditProductFormSchema = z.infer<
  ReturnType<typeof useEditProductFormSchema>
> & {
  specification: string;
};
